// Configuration for the Triple Point Trading Strategy app
// This file is used to override environment variables when they're not set

// Alpha Vantage API key
export const ALPHA_VANTAGE_API_KEY = '4XUFSRCV2N9NI533';

// API configuration - FORCE USING REAL API
export const USE_MOCK_API = false;
export const USE_REAL_API = true;

// Supabase configuration
export const SUPABASE_URL = 'https://iqcfquygxwgsgiokbhhl.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlxY2ZxdXlneHdnc2dpb2tiaGhsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1Nzg3MjksImV4cCI6MjA2MTE1NDcyOX0.vvyqz5tojG-dJFTn8I0T1WExeZzthzEcngUG1jBjwnM';

// Backend API URL
export const API_URL = 'http://localhost:8000/api';

// Cache duration in milliseconds (24 hours)
export const CACHE_DURATION = 24 * 60 * 60 * 1000;

// Get the actual environment variable or fallback to the config
export const getConfig = (envVar, fallback) => {
  return process.env[envVar] || fallback;
};

// Export the configuration with explicit settings
export default {
  apiKey: getConfig('REACT_APP_ALPHA_VANTAGE_API_KEY', ALPHA_VANTAGE_API_KEY),
  // Force useMockApi to false regardless of environment variable
  useMockApi: false,
  // Force useRealApi to true regardless of environment variable
  useRealApi: true,
  apiUrl: getConfig('REACT_APP_API_URL', API_URL),
  supabaseUrl: getConfig('REACT_APP_SUPABASE_URL', SUPABASE_URL),
  supabaseAnonKey: getConfig('REACT_APP_SUPABASE_ANON_KEY', SUPABASE_ANON_KEY),
  cacheDuration: parseInt(getConfig('REACT_APP_CACHE_DURATION', CACHE_DURATION.toString())),
}; 